<template>
	<div class="billing-panel">
		<table height="100%" width="100%" border="0" cellpadding=0 cellspacing=0>
            <tr height="56px">
                <td colspan=2>
                    <div class="panel-command-box">
                        <div class="panel-command-box-left" style="padding-bottom: 0px;">
                            <span v-t="'message.item_billing_month'"></span>
                            <div class="date-picker">
                                <el-date-picker
                                    v-model="pickedMonth"
                                    type="month"
                                    placeholder="Pick a month">
                                </el-date-picker>
                            </div>
                        </div>
                    </div>
                </td>
            </tr>
            <div v-if="billingInfos.length == 0" class="invoice-table">
                <span v-t="{ path: 'message.info_no_billable_in_period', args: { fromYear: pickedMonth.getFullYear() ,fromMonth: (pickedMonth.getMonth()+1) ,toYear: pickedMonth.getFullYear() ,toMonth: (pickedMonth.getMonth()+1) ,toDay: getLastDayOfMonth(pickedMonth)} }"/>
            </div>
            <tr v-else>
                <td style="vertical-align:top">
                    <div class="inner-panel">
                        <billing-description v-if="show" :billingInfos="billingInfos" :appData="appData" tenantCurrency="appData.tenantList[0].currency" :isPartnerConsole="false"></billing-description>
                    </div>
                </td>
            </tr>
		</table>
	</div>
</template>

<script>
import Vue from 'vue'
import server from "./ServerApi.js";
import BillingDescription from "./BillingDescription.vue"
import commonUtil from './commonutil.js';
import constants from './constants.js';

export default {
    data () {
        return {
            show: true,
            activeTenantId: 0,
            purchaseStartDate: null,
            pickedMonth: null,
            currentDate: null,
            billingInfos: []
        };
    },
    methods: {
        getBillingInfos() {
            let self = this;
            let from = new Date(this.pickedMonth.getFullYear(), this.pickedMonth.getMonth());
            let to = new Date(from.getFullYear(), from.getMonth() + 1);
            let input = {fromBillingDatetime: from.toISOString(), toBillingDatetime: to.toISOString()}
            server.post('/getbillinginfos', input)
            .then((res) => {
                if (res.data.status === constants.STATUS_SUCCESS) {
                    self.billingInfos = res.data.billingInfos;
                }
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "getBillingInfos", error);
            });
        },
        getLastDayOfMonth(targetDate) {
            return new Date(targetDate.getFullYear(), targetDate.getMonth() + 1, 0).getDate();
        }
    },
    components: {
        BillingDescription
    },
    watch: {
        pickedMonth: {
            handler(newVal, oldVal) {
                return this.getBillingInfos();
            }
        },
        '$route' (to, from) {
            if (to.name == "BillingForUser") {
                return this.getBillingInfos();
            }
        },
        'appData.menuExpand'(newVal) {
            this.show = false;
            this.$nextTick(() => {
                 this.show = true
            })
        }
    },
    created: function() {
        this.currentDate = new Date();
        this.pickedMonth = this.currentDate;
    },
    props: ['appData']
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.date-picker {
    padding-top: 0px;
    padding-bottom: 0px;
}
.date-picker >>> .el-input__inner {
    height: 36px;
}
.billing-panel {
	height: 100%;
	overflow-y: auto;
	min-width: 630px;
}

.inner-panel {
	position:relative;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: auto;
	background-color: #ffffff;
}
.invoice-table {
    margin: 20px;
}

</style>
